import React, { FC, useState, useEffect } from 'react'
import Card from 'components/base/Card'
import Button from 'components/base/forms/Button'
import CardTitle from './CardTitle'
import { useDefaultSubscription } from 'common/services/useDefaultSubscription'
import { useUpdateSubscriptionLocationMutation } from 'common/services/useAddress'
import { openConfirm } from 'components/base/Modal'

type AddressMigrationCardProps = {
  className?: string
}

const AddressMigrationCard: FC<AddressMigrationCardProps> = ({ className }) => {
  const { subscriptionDetail } = useDefaultSubscription()
  const [updateLocation, { isLoading }] =
    useUpdateSubscriptionLocationMutation()
  const [hasConfirmed, setHasConfirmed] = useState(false)

  // Reset hasConfirmed when subscription changes
  useEffect(() => {
    setHasConfirmed(false)
  }, [subscriptionDetail?.id])

  const isPartnerCustomer = subscriptionDetail?.is_partner_customer
  const requiresUpdate = subscriptionDetail?.location?.is_require_update

  // Only show for DIRECT customers who need location migration
  if (!subscriptionDetail || isPartnerCustomer || !requiresUpdate) {
    return null
  }

  const handleConfirm = () => {
    openConfirm(
      'Confirm move to 66 Paul Street',
      'Please ensure you have updated your records to reflect your new address.',
      async (closeModal) => {
        try {
          await updateLocation({
            subscription_id: subscriptionDetail.id,
          }).unwrap()
          setHasConfirmed(true)
          closeModal()
        } catch (error) {
          // Error handled by RTK Query
        }
      },
    )
  }

  if (hasConfirmed) {
    return null
  }

  return (
    <div className={className}>
      <Card>
        <div className='flex-fill'>
          <CardTitle
            title={'ADDRESS UPDATE'}
            subtitle={'Welcome to our new headquarters'}
          />
          <p className='fs-lg mb-3'>
            We've moved our headquarters to <strong>66 Paul Street</strong>,
            just <strong>55 metres</strong> from our previous address. Our
            former address, <strong>86–90 Paul Street</strong>, remains valid
            until <strong>May 2030</strong>, but we recommend updating your
            records to reflect our new headquarters address.
          </p>
          <p className='mb-4'>
            Need help updating your records?{' '}
            <a
              href='https://help.hoxtonmix.com/en/article/the-ultimate-guide-updating-your-business-address-11u803a/'
              target='_blank'
              rel='noreferrer'
              className='text-primary'
            >
              View our address update guide
            </a>
          </p>
        </div>
        <Button className='w-100' onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? 'Updating...' : 'Confirm update to 66 Paul Street'}
        </Button>
      </Card>
    </div>
  )
}

export default AddressMigrationCard
